import { render, staticRenderFns } from "./HKLKPI.vue?vue&type=template&id=23af295e&"
import script from "./HKLKPI.vue?vue&type=script&lang=js&"
export * from "./HKLKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports